<template>
  <section class="pt-32 mb-24 px-4 max-w-screen-3xl mx-auto">
    <h2>Patrocinadores</h2>
    <div class="md:flex md:flex-wrap md:flex-shrink md:justify-center">
      <article
        v-for="partner in partnersList"
        :key="partner.pk"
        class="relative border mx-auto pt-12 my-6 w-full max-w-sm sm:w-88 sm:max-w-none md:mx-3 flex items-center justify-center"
        :class="[partner.partner_type.slug === 'gold' ? 'lg:w-196' : 'lg:w-88']"
      >
        <figure class="text-main-400 h-full flex flex-col justify-between">
          <div
            v-if="partner.partner_type.slug === 'gold'"
            class="uppercase text-left pl-8 flex items-center"
          >
            <span class="gold"></span>
            <span class="pl-2">
              Patrocinador {{ partner.partner_type.partner_type }}
            </span>
          </div>

          <div>
            <div class="h-40 flex items-center justify-center">
              <img
                class="w-56 px-4"
                :class="[
                  partner.partner_type.slug === 'gold' ? 'lg:w-120' : 'lg:w-56',
                ]"
                :src="partner.image"
                :alt="partner.company"
              />
            </div>

            <figcaption class="text-left mt-12 px-4">
              <div
                v-if="partner.partner_type.slug !== 'gold'"
                class="uppercase text-sm font-bold"
              >
                Patrocinador
                <span v-if="partner.partner_type.slug === 'silver'">
                  {{ partner.partner_type.partner_type }}
                </span>
              </div>

              <div class="mt-6 mb-12 pl-6">
                <h3 class="uppercase text-xl mb-3">{{ partner.company }}</h3>
                <p class="text-sm">{{ partner.description }}</p>
              </div>
            </figcaption>
          </div>

          <div class="border-t text-left text-secondary-500 pl-12 py-2 text-sm">
            <a
              :href="partner.url"
              class="flex items-center hover:underline"
              target="_blank"
            >
              <span> Ir a {{ partner.company }} </span>
              <span class="pl-2 text-xs">
                <BaseIcon name="external-link-alt" />
              </span>
            </a>
          </div>
        </figure>
      </article>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('partners', ['partnersList']),
  },

  mounted() {
    this.$store.dispatch('partners/fetchpartnersList')
  },
}
</script>

<style scoped>
.gold {
  @apply block w-4 h-4 bg-secondary-500 rounded-full;
}
</style>
